import type React from "react";
import {
  Calendar as ShadcnCalendar,
  CalendarDayButton as ShadcnCalendarDayButton,
} from "src/shadcn/components/calendar";

const Calendar = (props: React.ComponentProps<typeof ShadcnCalendar>) => (
  <ShadcnCalendar {...props} />
);

const CalendarDayButton = (
  props: React.ComponentProps<typeof ShadcnCalendarDayButton>
) => <ShadcnCalendarDayButton {...props} />;

export { Calendar, CalendarDayButton };
